import { render, staticRenderFns } from "./EcommerceMeetup.vue?vue&type=template&id=8774daf8"
import script from "./EcommerceMeetup.vue?vue&type=script&lang=js"
export * from "./EcommerceMeetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports